import { PlausibleDirective } from '@agilox/directive/plausible';
import { CustomDatePipe } from '@agilox/pipe/custom-date';
import { TrustedPipe } from '@agilox/pipe/trusted';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserNotificationItemComponent } from './user-notification/user-notification-item.component';
import { UserNotificationsButtonComponent } from './user-notifications-button/user-notifications-button.component';
import { UserNotificationsComponent } from './user-notifications.component';
import {
	BadgeDirective,
	ButtonComponent,
	DividerComponent,
	HeadlineComponent,
	OffcanvasComponent,
	SpinnerComponent,
	TagComponent,
} from '@agilox/ui';
import { NotificationsService } from '../notifications/notifications.service';
import { NotificationReadsService } from '../notification-reads/notification-reads.service';
import { LangValuePipe } from '@agilox/common';

@NgModule({
	declarations: [
		UserNotificationsComponent,
		UserNotificationsButtonComponent,
		UserNotificationItemComponent,
	],
	imports: [
		CommonModule,
		OffcanvasComponent,
		TrustedPipe,
		SpinnerComponent,
		ButtonComponent,
		TranslateModule,
		HeadlineComponent,
		ButtonComponent,
		DividerComponent,
		TagComponent,
		BadgeDirective,
		CustomDatePipe,
		LangValuePipe,
		PlausibleDirective,
	],
	exports: [
		UserNotificationsComponent,
		UserNotificationsButtonComponent,
		UserNotificationItemComponent,
	],
	providers: [NotificationsService, NotificationReadsService],
})
export class UserNotificationsModule {}
